import * as React from 'react';
import { ReactComponent as AlertSuccessIcon } from '../../../assets/images/notification-success.svg';
import { ReactComponent as AlertErrorIcon } from '../../../assets/images/ill_banner_error.svg';

export function Success(props: {
  text: string;
  additionalClass?: string;
  title?: string;
}) {
  return (
    <div className={`alert-container alert-success ${props.additionalClass}`}>
      <span className="alert-icon">
        <AlertSuccessIcon aria-label="Notification Success" />
      </span>
      <div className="alert-texts">
        <span className="alert-title">{props.title}</span>
        <span className="alert-text">{props.text}</span>
      </div>
    </div>
  );
}

export function ErrorNotification(props: { text: string; title?: string }) {
  return (
    <div className="errors-box form-global-errors alert-container">
      <span className="error-icon alert-icon">
        <AlertErrorIcon aria-label="Error" />
      </span>
      <div className="error-list">
        {props.title && (
          <span>
            <b>{props.title}</b>
          </span>
        )}
        <span>{props.text}</span>
      </div>
    </div>
  );
}
